module.exports = __webpack_public_path__ + "static/media/respeito.e11af9fc.jpg";